/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui';

/* ++++++++++ --------------- TRIVIA POLL ANALYTICS - UNIQUE TRIVIA USERS REPORT : STYLES --------------- ++++++++++ */
export default {
    uniqueTriviaUsersReport: {
        marginBottom: pxToEm(16),
        marginTop: pxToEm(16),
    }
};